import type { BlogPost } from "./blog";

export const BLOG_EVENTS_PART2: BlogPost[] = [
  {
    "slug": "svadba-na-30-chelovek-restoran-spb",
    "title": "Свадьба на 30 человек в ресторане СПб: интимное торжество",
    "metaTitle": "Свадьба на 30 человек в ресторане СПб — Паруса на крыше",
    "metaDescription": "Свадьба на 30 человек в ресторане Петербурга. «Паруса на крыше» — приватный зал с видом, авторское свадебное меню, живая музыка. Бронирование и цены.",
    "keywords": "свадьба 30 человек ресторан спб, небольшая свадьба ресторан петербург, свадебный банкет 30 человек спб",
    "date": "2026-06-08",
    "category": "Свадьба",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Небольшая свадьба на 30 человек — это не компромисс, а осознанный выбор. Только самые близкие, атмосфера вместо масштаба, каждый гость важен. Для такого формата нужен ресторан, который понимает это.",
    "sections": [
      {
        "heading": "Почему 30 гостей — это идеальная свадьба",
        "body": "Свадьба на 30 человек сохраняет то, что теряется на больших торжествах: живое общение с каждым гостем, возможность услышать каждый тост, атмосферу настоящего праздника без логистического хаоса. «Паруса на крыше» для такого формата предлагают отдельный зал с видом на исторический центр Петербурга, сервис с персональным вниманием к каждому столику и кухню, которая держит уровень для тридцати гостей так же, как для трёх.",
        "list": [
          "Отдельный зал — только ваши гости, без посторонних",
          "Вид на купола и крыши — декорация, которая работает без флориста",
          "Синхронная подача блюд — все едят вместе, тосты в нужный момент",
          "Банкетное меню от 2 500 ₽/чел. — прозрачный бюджет"
        ]
      },
      {
        "heading": "Сценарий свадьбы на 30 человек",
        "body": "Оптимальная структура: торжественная встреча с шампанским у входа или в зале (15 минут), общее фото с видом на Петербург, переход к банкетным столам, слово молодожёнов и родителей, первые закуски. Затем — последовательные перемены блюд, тосты, первый танец. Финал — торт, десертный стол, живая музыка и неформальное общение. Весь вечер — 4–5 часов, без ощущения марафона."
      },
      {
        "heading": "Бюджет свадьбы на 30 человек в «Парусах»",
        "body": "Банкетное меню 2 500 ₽ × 30 = 75 000 ₽. Алкоголь: 800–1 000 ₽ × 30 = 24 000–30 000 ₽. Итого еда + напитки: 99 000–105 000 ₽. Живая музыка на 3 часа: 30 000–50 000 ₽ (опционально). Оформление зала: 10 000–30 000 ₽ в зависимости от выбора флориста. Свадьба на 30 человек в панорамном ресторане центра Петербурга — реально за 150 000–200 000 ₽.",
        "highlight": "Для небольшой свадьбы (до 35 гостей) в «Парусах» доступны даты на 3–4 месяца вперёд. Бронировать: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Обсудить свадьбу на 30 человек",
      "href": "/svadba"
    }
  },
  {
    "slug": "yubilej-svadby-25-let-spb",
    "title": "Юбилей свадьбы 25 лет: где отметить серебряную свадьбу в СПб",
    "metaTitle": "Юбилей свадьбы 25 лет в СПб — серебряная свадьба | Паруса на крыше",
    "metaDescription": "Где отметить серебряную свадьбу (25 лет) в Санкт-Петербурге? «Паруса на крыше» — особый вечер с видом на город, живая музыка, авторская кухня. Бронирование.",
    "keywords": "юбилей свадьбы 25 лет спб, серебряная свадьба петербург ресторан, 25 лет свадьба где отметить спб",
    "date": "2026-06-08",
    "category": "Свадьба",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Двадцать пять лет вместе — серебряная свадьба. Это не просто дата, это история, которую стоит отметить особым образом. Петербург для этого создан идеально: город с историей для пары с историей.",
    "sections": [
      {
        "heading": "Серебряная свадьба: особый формат",
        "body": "На двадцатипятилетнем юбилее свадьбы состав гостей, как правило, особенный: взрослые дети, близкие друзья, те, кто был на самой свадьбе. Это тёплая, камерная атмосфера — не шумное торжество, а вечер воспоминаний и благодарности. «Паруса на крыше» идеально подходят для такого формата: панорамный ресторан с авторской кухней, где можно провести неспешный вечер с красивым видом и хорошим вином.",
        "list": [
          "Камерный формат для 15–30 гостей — выделенная зона",
          "Серебряное оформление стола — по запросу",
          "Лучшие блюда из авторского меню для особого вечера",
          "Живая музыка — по запросу, для создания атмосферы"
        ]
      },
      {
        "heading": "Традиции серебряной свадьбы в ресторане",
        "body": "На серебряную свадьбу принято: обновить клятвы (можно организовать в ресторане как трогательный момент), вернуться к фотографиям со свадьбы — это становится поводом для разговора за столом, заказать торт с серебряными акцентами. Живая музыка с любимыми мелодиями пары — ещё одна традиция, которую легко организовать в «Парусах»."
      },
      {
        "heading": "Как организовать особый вечер",
        "body": "Свяжитесь с менеджером ресторана и расскажите о поводе: +7 (812) 991-10-90. Обсудите состав гостей, предпочтения в меню и пожелания по музыке. Для серебряной свадьбы можно заказать специальные детали оформления — серебряные акценты в декоре, свечи, живые цветы.",
        "highlight": "Для серебряной свадьбы — особые условия. Позвоните менеджеру заранее и уточните, какие дополнительные сюрпризы мы можем подготовить для пары."
      }
    ],
    "cta": {
      "text": "Организовать юбилей свадьбы",
      "href": "/svadba"
    }
  },
  {
    "slug": "devichnik-na-kryshe-peterburg",
    "title": "Девичник на крыше в Петербурге: форматы и идеи",
    "metaTitle": "Девичник на крыше в Петербурге — Паруса на крыше | Идеи",
    "metaDescription": "Девичник на крыше в Санкт-Петербурге. «Паруса на крыше» — приватная зона с панорамой города, авторская кухня, дегустация вин и коктейлей. Как организовать.",
    "keywords": "девичник крыша петербург, девичник ресторан крыша спб, девичник на высоте петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Девичник на крыше — это когда фотографии красивее любого фильтра, потому что за спиной Петербург. И когда воспоминания останутся не о конкурсах, а о разговорах — за видом на закат и хорошим вином.",
    "sections": [
      {
        "heading": "Что такое девичник на крыше в «Парусах»",
        "body": "«Паруса на крыше» — ресторан на 6-м этаже Olympic Plaza (ул. Марата, 5) с панорамным видом на исторический центр Петербурга. Для девичника здесь выделяется отдельная зона или банкетный зал — в зависимости от размера компании. Никаких посторонних гостей рядом, только ваша группа и вид на город. Летом доступна открытая терраса — девичник под открытым небом с Петербургом у ног.",
        "list": [
          "Приватная зона — только ваша компания",
          "Открытая терраса летом — ужин под открытым небом",
          "Дегустация вин и коктейлей — по запросу",
          "Авторская кухня — лёгкие закуски и десерты для девичника"
        ]
      },
      {
        "heading": "Программа девичника: что работает",
        "body": "Самые популярные форматы девичника в «Парусах»: дегустация вин (5–6 позиций с кратким рассказом о каждом — организуется при заказе), коктейльный вечер (авторские коктейли для группы с названиями в честь невесты и подружек), фотосессия на фоне панорамы (закат или ночной Петербург — лучший фон), просто ужин с разговорами (иногда лучший девичник — красивое место без программы)."
      },
      {
        "heading": "Как организовать",
        "body": "Для компании 6–12 человек бронируйте за 1–2 недели, для 15+ — за 2–3 недели. Укажите, что это девичник: ресторан подготовит приватную зону. Если хотите дегустацию или специальную коктейльную программу — сообщите за 5–7 дней, чтобы успели подготовить. Для декора зала (шары, баннер «Невеста», цветы) — лучше принести своё или согласовать с менеджером.",
        "highlight": "Июнь-август — лучшее время для девичника на открытой террасе с видом на Петербург. Бронируйте летние даты в апреле-мае."
      }
    ],
    "cta": {
      "text": "Забронировать девичник",
      "href": "/banket"
    }
  },
  {
    "slug": "devichnik-degustatsiya-vin-spb",
    "title": "Девичник с дегустацией вин в ресторане СПб: идеи и организация",
    "metaTitle": "Девичник с дегустацией вин в СПб — Паруса на крыше",
    "metaDescription": "Девичник с дегустацией вин в Санкт-Петербурге. «Паруса на крыше» — приватная зона, подборка вин, авторские блюда. Организуем незабываемый девичник с дегустацией.",
    "keywords": "девичник дегустация вин спб, дегустация вин девичник петербург, вино девичник ресторан спб",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Дегустация вин на девичнике — это не «просто выпить», а познавательный и очень красивый формат. Несколько бокалов разных вин, краткий рассказ о каждом, авторские закуски и хорошая компания — вечер, который запомнится.",
    "sections": [
      {
        "heading": "Как устроена дегустация вин в «Парусах»",
        "body": "Для группы от 6 человек ресторан организовывает мини-дегустацию: 4–6 позиций из винной карты — белые, красные, игристые. К каждому вину — краткая история: страна, терруар, с чем сочетается. Всё это — в приватной зоне с видом на Петербург, в формате «говорите громко и смейтесь»: никакой академической строгости, только удовольствие.",
        "list": [
          "4–6 вин для группы — подбирается заранее с менеджером",
          "Лёгкие закуски к каждому вину — входят в формат",
          "Приватная зона без посторонних гостей",
          "Вид на Петербург — лучший декор для вечера с вином"
        ]
      },
      {
        "heading": "Какие вина выбрать для девичника",
        "body": "Для девичника обычно берут несколько типов: игристое на аперитив (просекко или шампанское), лёгкое белое (пино гри или совиньон блан), розовое вино (универсальный выбор для компании), и что-то чуть более основательное — каберне или мальбек, чтобы был контраст. Такая программа создаёт нарратив вечера: от лёгкого к более насыщенному."
      },
      {
        "heading": "Стоимость и организация",
        "body": "Стоимость дегустации зависит от выбранных вин и количества человек. Базово: 500–1 500 ₽/чел. за вина + лёгкие закуски. Добавьте к этому авторский ужин — и вечер получается насыщенным и запоминающимся. Организовывается при бронировании: сообщите о формате за 5–7 дней.",
        "highlight": "Хотите, чтобы вечер начался с бокала игристого «от ресторана» для группы невесты? Сообщите при бронировании — это организовывается как приятный сюрприз."
      }
    ],
    "cta": {
      "text": "Организовать девичник с дегустацией",
      "href": "/banket"
    }
  },
  {
    "slug": "malchishnik-restoran-spb",
    "title": "Мальчишник в ресторане Санкт-Петербурга: форматы и идеи",
    "metaTitle": "Мальчишник в ресторане Санкт-Петербурга — Паруса на крыше",
    "metaDescription": "Мальчишник в ресторане Санкт-Петербурга. «Паруса на крыше» — авторская кухня, хоспер-блюда, живая музыка, кальян по запросу. Как организовать незабываемый мальчишник.",
    "keywords": "мальчишник ресторан санкт-петербург, мальчишник спб ресторан, ресторан мальчишник петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Мальчишник — не обязательно клуб и кричалки. Это вечер, который должен быть memorable: хорошая компания, правильная еда и место, которое задаёт тон. Ресторан на крыше Петербурга — один из лучших вариантов.",
    "sections": [
      {
        "heading": "Мальчишник в формате ресторана: почему это работает",
        "body": "Хороший мальчишник в ресторане — это: хоспер-блюда и мясо на углях (в «Парусах» это делают отлично), хорошее пиво и вино (карта разнообразная), живая музыка как фон (не мешает разговорам), и приватная зона, где можно говорить в полный голос. Ресторан на крыше добавляет к этому вид на Петербург — аргумент, который сложно переоценить для группы.",
        "list": [
          "Хоспер — мясо на живом угле, лучшее блюдо для мальчишника",
          "Карта пива и вина — большой выбор",
          "Приватная зона с отдельным обслуживанием",
          "Живая музыка по выходным — без дополнительных затрат"
        ]
      },
      {
        "heading": "Программа мальчишника",
        "body": "Мальчишник в «Парусах» обычно строится просто: приходите, занимаете приватную зону с видом на город, заказываете горячие блюда на хоспере и закуски к столу, пьёте в своём темпе, разговариваете. Без обязательной программы — просто лучшая версия «посидеть с ребятами». Если хотите живую музыку или особое меню — согласовывается заранее."
      },
      {
        "heading": "Как забронировать",
        "body": "Бронирование для мальчишника: укажите количество человек и желаемое время. Для группы 6–12 человек — выделенная зона в общем зале. Для 15+ — отдельный зал. Хотите кальян — уточните этот вопрос при бронировании, ресторан имеет кальянное меню.",
        "highlight": "Компания от 10 человек — рекомендуем звонить: +7 (812) 991-10-90. Менеджер подберёт оптимальный формат для вашего вечера."
      }
    ],
    "cta": {
      "text": "Забронировать мальчишник",
      "href": "/banket"
    }
  },
  {
    "slug": "delovoy-uzhin-restoran-peterburg",
    "title": "Деловой ужин в ресторане Петербурга: как провести переговоры",
    "metaTitle": "Деловой ужин в ресторане Петербурга — Паруса на крыше",
    "metaDescription": "Деловой ужин в ресторане Санкт-Петербурга. «Паруса на крыше» — панорамный ресторан для деловых встреч, переговоров и бизнес-ужинов. Приватные зоны.",
    "keywords": "деловой ужин ресторан петербург, бизнес-ужин спб, деловые переговоры ресторан петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Деловой ужин — продолжение переговоров в другом формате. Место снимает официальность офиса и создаёт контекст для более открытого разговора. Выбор ресторана здесь — часть деловой стратегии.",
    "sections": [
      {
        "heading": "Зачем проводить деловые переговоры за ужином",
        "body": "Исследования показывают: совместная еда снижает психологические барьеры и повышает доверие между сторонами переговоров. Ресторан создаёт нейтральную территорию — не офис одной из сторон, не формальный зал заседаний. «Паруса на крыше» — нейтральная территория высокого класса: рейтинг 5,0, 15 лет репутации, панорама Петербурга как общий контекст для любых гостей.",
        "list": [
          "Нейтральная территория — не офис ни одной из сторон",
          "Деликатный сервис — не мешает разговору",
          "Приватные зоны и угловые столики для конфиденциальных встреч",
          "Бизнес-ланч от 590 ₽ или à la carte для ужина"
        ]
      },
      {
        "heading": "Как выбрать стол для делового ужина",
        "body": "Для переговоров тет-а-тет: угловой столик у окна с видом — приватность и красивый фон. Для встречи 4–6 человек: круглый или квадратный стол без «главы стола» — равноправный формат. Для презентации партнёрам: выделенная зона или отдельный зал с возможностью подключить ноутбук. При бронировании сообщите о формате встречи — официант учтёт это в подходе."
      },
      {
        "heading": "Этикет делового ужина: несколько правил",
        "body": "Не заказывайте блюда, которые сложно есть аккуратно (спагетти, рёбра). Дайте гостю выбрать первым. Алкоголь — только если гость сам предложит или возьмёт. Телефон убирайте под стол. Счёт: тот, кто пригласил — платит. В «Парусах» счёт можно попросить принести незаметно, заранее предупредив официанта.",
        "highlight": "Для регулярных деловых встреч сообщите об этом персоналу — ресторан запоминает постоянных гостей и их предпочтения."
      }
    ],
    "cta": {
      "text": "Забронировать деловой ужин",
      "href": "/"
    }
  },
  {
    "slug": "vypusknoy-11-klass-restoran-peterburg",
    "title": "Ресторан на выпускной 11 класс в Петербурге: как выбрать",
    "metaTitle": "Ресторан на выпускной 11 класс в Петербурге — Паруса на крыше",
    "metaDescription": "Где провести выпускной 11 класса в ресторане Петербурга? «Паруса на крыше» — банкет с видом на город, живая музыка, авторская кухня. Цены и бронирование.",
    "keywords": "ресторан выпускной 11 класс петербург, выпускной 11 класс ресторан спб, выпускной банкет петербург 11 класс",
    "date": "2026-06-10",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Выпускной 11 класса — первый взрослый вечер в жизни. Место для него должно соответствовать этому статусу: не детское кафе с воздушными шарами, а настоящий ресторан с красивым видом и правильной атмосферой.",
    "sections": [
      {
        "heading": "Выпускной 11 класса: чего хотят выпускники",
        "body": "Современные выпускники хотят провести этот вечер по-взрослому: красивое место, хорошая еда, фотографии, которые будут интересно смотреть через 10 лет. «Паруса на крыше» дают именно это: панорама Петербурга с 6-го этажа Olympic Plaza — один из лучших фонов для выпускных фотографий. Ресторан работает с группами от 20 до 300 человек, поэтому любой класс вписывается.",
        "list": [
          "Панорама города — идеальный фон для выпускных фото",
          "Банкет для группы 20–50 человек — отдельный зал",
          "Живая музыка в выходные — атмосфера без DJ-оборудования",
          "Безалкогольные коктейли и авторское меню для молодёжи"
        ]
      },
      {
        "heading": "Программа выпускного 11 класса в ресторане",
        "body": "Стандартная программа: сбор класса, общие фотографии у панорамных окон, переход к столам, слово классного руководителя и нескольких выпускников, ужин с несколькими переменами блюд, живая музыка или плейлист во второй части вечера, вынос торта с поздравлением класса. Если есть родители — они могут занять отдельный стол рядом или провести вечер в другом зале."
      },
      {
        "heading": "Организационные вопросы",
        "body": "Кто организует: классный руководитель или родительский комитет. Оптимально бронировать в апреле-мае — выпускные в конце июня. Меню для выпускного: лёгкие закуски, горячее, десертный стол, безалкогольные напитки. Алкоголь — строго 18+, ресторан соблюдает это правило.",
        "highlight": "Июнь — пик выпускных. Лучшие даты разбирают к маю. Начните звонить в апреле: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать выпускной",
      "href": "/banket"
    }
  },
  {
    "slug": "restoran-na-8-marta-peterburg",
    "title": "Ресторан на 8 Марта в Петербурге: куда пойти в Международный женский день",
    "metaTitle": "Ресторан на 8 Марта в Петербурге — Паруса на крыше | Бронирование",
    "metaDescription": "Куда пойти на 8 Марта в ресторан в Петербурге? «Паруса на крыше» — особое праздничное меню, живая музыка, панорама города. Бронирование на 8 марта.",
    "keywords": "ресторан 8 марта петербург, куда пойти 8 марта спб ресторан, 8 марта ресторан санкт-петербург",
    "date": "2026-06-10",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "8 Марта в ресторане — лучший подарок, который не нужно угадывать. Особенно когда ресторан — с панорамой Петербурга, живой музыкой и авторской кухней.",
    "sections": [
      {
        "heading": "Почему 8 Марта в ресторане — хорошая идея",
        "body": "8 Марта — день, когда всё закрыто или переполнено, если не озаботиться заранее. В «Парусах на крыше» этот день особенный: праздничное меню с весенними блюдами, живая музыка с праздничной программой, цветы от ресторана каждой гостье. Рейтинг 5,0 и «Хорошее место 2026» говорят о том, что ресторан умеет делать праздничные дни по-настоящему праздничными.",
        "list": [
          "Праздничное меню 8 Марта — уточняйте в сезон",
          "Цветы каждой гостье — фирменный жест ресторана",
          "Живая музыка с весенней праздничной программой",
          "Скидка 20% для именинниц (у кого ДР близко к 8 Марта)"
        ]
      },
      {
        "heading": "Форматы на 8 Марта: с кем идти",
        "body": "Романтический ужин для пары — столик у окна с закатом и видом на Петербург: самый популярный формат. Семейный обед — для всей семьи с мамами и бабушками: выделенная зона, авторская кухня для любого возраста. Девичник в Женский день — стильный вариант: идти всем подружкам вместе, заказать дегустацию вин и отпраздновать день по-своему."
      },
      {
        "heading": "Важно: бронировать заранее",
        "body": "8 Марта — одна из самых востребованных дат года. В «Парусах» в этот день зал занят полностью. Бронирование открывается в январе-феврале и закрывается к началу марта. Если хотите конкретное время — бронируйте за 2–3 недели минимум.",
        "highlight": "Бронирование на 8 Марта — только по телефону или онлайн. Обязательно сделайте это заранее: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать стол на 8 Марта",
      "href": "/"
    }
  },
  {
    "slug": "kuda-pojti-posle-vypusknogo-spb",
    "title": "Куда пойти после выпускного вечера в СПб: идеи и рестораны",
    "metaTitle": "Куда пойти после выпускного в СПб — Паруса на крыше | Идеи",
    "metaDescription": "Куда пойти после выпускного в Петербурге? Рестораны, которые работают допоздна. «Паруса на крыше» — авторская кухня, вид на ночной город, живая музыка.",
    "keywords": "куда пойти после выпускного спб, после выпускного петербург куда, выпускной ночь спб куда идти",
    "date": "2026-06-10",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Выпускной закончился, а ночь только начинается. Куда идти дальше? Петербург — ночной город, и для первой взрослой ночи здесь много правильных адресов.",
    "sections": [
      {
        "heading": "Варианты для ночи после выпускного",
        "body": "После официального выпускного компании обычно разделяются: одни едут на набережную Невы встречать рассвет, другие — в ночные кафе или рестораны, третьи — в клубы. Для тех, кто хочет продолжить в красивом месте без клубного шума — «Паруса на крыше» работают до позднего вечера и дают то, чего нет в ночных клубах: вид на ночной Петербург, авторскую кухню и живую музыку.",
        "list": [
          "Ночной вид на Петербург с 6-го этажа — лучше любого клуба",
          "Авторская кухня — поздний ужин или лёгкие закуски",
          "Живая музыка в выходные вечером",
          "Безалкогольные коктейли для тех, кто не пьёт"
        ]
      },
      {
        "heading": "Маршрут ночи после выпускного в Петербурге",
        "body": "Рекомендуемый маршрут: выпускной (19:00–23:00) → «Паруса на крыше» на поздний ужин (23:00–01:00) → прогулка по набережной Невы → смотреть развод мостов (01:30–02:30 в период навигации). Этот маршрут даёт полный «петербургский выпускной опыт» — в красивом городе, в красивых местах."
      },
      {
        "heading": "Практически о поздних визитах",
        "body": "Для позднего ужина после выпускного рекомендуем бронировать заранее и уточнять время закрытия кухни. В пиковые даты (последние дни июня) ресторан работает допоздна, но кухня может закрыться раньше. Звоните: +7 (812) 991-10-90.",
        "highlight": "В белые ночи (конец мая — начало июля) «Паруса» — одно из лучших мест для ночного ужина с видом на Петербург в 23:00."
      }
    ],
    "cta": {
      "text": "Забронировать поздний ужин",
      "href": "/"
    }
  },
  {
    "slug": "korporativ-zhivaya-muzyka-restoran",
    "title": "Корпоратив с живой музыкой в ресторане Петербурга",
    "metaTitle": "Корпоратив с живой музыкой в ресторане Петербурга — Паруса на крыше",
    "metaDescription": "Корпоратив с живой музыкой в ресторане Санкт-Петербурга. «Паруса на крыше» — джазовые выступления, авторская кухня, банкетный зал до 300 гостей.",
    "keywords": "корпоратив живая музыка ресторан петербург, корпоратив джаз спб, живая музыка корпоратив ресторан",
    "date": "2026-06-10",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Живая музыка на корпоративе — это не опция, а разница между мероприятием, которое забудут через неделю, и вечером, о котором вспоминают. Правильная музыка меняет атмосферу быстрее, чем любой декор.",
    "sections": [
      {
        "heading": "Почему живая музыка важна для корпоратива",
        "body": "Фоновая плейлист-музыка создаёт паузы в разговоре. Живые музыканты — создают атмосферу. Разница в восприятии — принципиальная. Исследования в области event-management показывают: корпоративы с живой музыкой оцениваются участниками на 30–40% выше, чем аналогичные мероприятия без неё. В «Парусах на крыше» живая музыка — часть ДНК ресторана: джазовые исполнители играют здесь регулярно, а для корпоративов можно заказать специальную программу.",
        "list": [
          "Штатные джазовые исполнители — выступают в расписании афиши",
          "Специальная программа для корпоратива — по запросу",
          "Корпоративный гимн или любимая песня команды — возможно",
          "Сцена, звук, свет — профессиональное оснащение в комплекте"
        ]
      },
      {
        "heading": "Какую музыку выбрать для корпоратива",
        "body": "Для официальной части и ужина: джазовый квартет или трио — универсальный выбор, который нравится всем возрастам. Для танцевальной части: диджей или кавер-группа с живыми инструментами. Для тематического корпоратива (70-е, 80-е, новый год): программа под тему. В «Парусах» можно организовать как выступление из афиши, так и заказную программу."
      },
      {
        "heading": "Как включить музыку в бюджет",
        "body": "Если корпоратив совпадает с плановым концертом из афиши — живая музыка входит в вечер без дополнительных затрат. Для заказной программы: джазовый дуэт на 3 часа — от 30 000 ₽. Кавер-группа на 3–4 часа — от 60 000 ₽. При бюджете корпоратива 150 000–200 000 ₽ живая музыка — это 15–30% от суммы, которые окупаются вовлечённостью команды.",
        "highlight": "Проверьте афишу перед выбором даты корпоратива — если совпадёте с концертом, живая музыка будет бонусом. Расписание на сайте или по телефону: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Обсудить корпоратив с живой музыкой",
      "href": "/korporativ"
    }
  },
  {
    "slug": "letnyy-korporativ-terrasa-spb",
    "title": "Летний корпоратив на террасе в СПб: как организовать",
    "metaTitle": "Летний корпоратив на террасе в СПб — Паруса на крыше | Организация",
    "metaDescription": "Летний корпоратив на открытой террасе в Петербурге. «Паруса на крыше» — терраса с видом на город, авторская кухня, живая музыка. До 300 гостей.",
    "keywords": "летний корпоратив терраса спб, корпоратив открытая терраса петербург, летний корпоратив на свежем воздухе спб",
    "date": "2026-06-11",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Летний корпоратив на свежем воздухе — то, что команда ждёт после долгой зимы. Открытая терраса над Петербургом, белые ночи и лёгкие ужины с видом на купола — это не просто мероприятие, а событие.",
    "sections": [
      {
        "heading": "Летний корпоратив в «Парусах»: что это",
        "body": "Летом в «Парусах на крыше» открывается открытая терраса — площадка на 6-м этаже Olympic Plaza под открытым небом с видом на исторический центр Петербурга. Для корпоратива здесь можно организовать как фуршет (гости стоят и общаются с видом на город), так и сидячий формат. Белые ночи добавляют этому формату уникальность: корпоратив в 22:00 под светлым небом Петербурга — это то, о чём рассказывают коллегам из других городов.",
        "list": [
          "Открытая терраса — доступна с мая по сентябрь в хорошую погоду",
          "Белые ночи (июнь–июль) — уникальный формат корпоратива",
          "Фуршет или сидячий ужин — оба варианта на террасе",
          "Запасной план: переход в закрытый зал при непогоде"
        ]
      },
      {
        "heading": "Программа летнего корпоратива",
        "body": "Летний формат более расслабленный, чем осенне-зимний. Cocktail hour на открытой террасе (45–60 минут) — гости собираются, смотрят на Петербург, общаются. Затем — переход к лёгкому ужину: летние блюда (морепродукты, лёгкие пасты, гриль), свежие напитки. Музыкальный фон — живые музыканты или лёгкий плейлист. Завершение — в момент, когда небо приобретает оттенки белой ночи."
      },
      {
        "heading": "Летние даты: когда бронировать",
        "body": "Терраса доступна с мая по сентябрь, но лучшие даты — июнь–июль (белые ночи). Для корпоратива на террасе рекомендуем бронировать за 4–6 недель: даты разбирают быстро. Важно: терраса зависит от погоды, поэтому при бронировании согласуйте «запасной план» — переход в закрытый зал при дожде.",
        "highlight": "Корпоратив в белые ночи (20 июня ± 10 дней) — самый запоминающийся формат года. Бронируйте в апреле: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать летний корпоратив",
      "href": "/korporativ"
    }
  },
  {
    "slug": "korporativ-zima-peterburg",
    "title": "Корпоратив зимой в Петербурге: где провести в декабре",
    "metaTitle": "Корпоратив зимой в Петербурге — лучшие рестораны | Паруса на крыше",
    "metaDescription": "Корпоратив зимой в Петербурге — где провести? «Паруса на крыше» — зимний вид на снежный город, новогоднее меню, живая музыка. Банкет до 300 гостей.",
    "keywords": "корпоратив зима петербург, зимний корпоратив спб, корпоратив декабрь петербург ресторан",
    "date": "2026-06-11",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Зимний Петербург — особый. Заснеженные купола, рождественские огни на Невском, морозный воздух и белые ночи, сменившиеся на долгие зимние вечера. Корпоратив в декабре на крыше этого города — событие, которое запоминается.",
    "sections": [
      {
        "heading": "Зимний Петербург для корпоратива",
        "body": "Зима добавляет ресторану «Паруса на крыше» особую атмосферу. С 6-го этажа Olympic Plaza в декабре видно: заснеженные купола Казанского собора с гирляндами, освещённые рождественскими огнями крыши центра, ночной город в праздничном убранстве. Это декорации, которые не нужно создавать — они сделаны временем года.",
        "list": [
          "Зимний вид: заснеженные купола и рождественские огни",
          "Горячие блюда и глинтвейн — зимнее меню ресторана",
          "Банкетный зал до 300 гостей — тепло в любой мороз",
          "Праздничная новогодняя программа — декабрь, по запросу"
        ]
      },
      {
        "heading": "Декабрь — пиковый месяц: что нужно знать",
        "body": "Декабрь в Петербурге — самый загруженный месяц для корпоративов. Рестораны в хороших локациях закрываются для мероприятий почти целиком. «Паруса» не исключение: конец ноября — начало декабря — ключевое время для бронирования. Лучшие даты декабря (особенно 22–28) разбирают в сентябре."
      },
      {
        "heading": "Как сэкономить на зимнем корпоративе",
        "body": "Перенесите дату на ноябрь или январь — цены и доступность значительно лучше. Выберите будний вечер — меньше конкуренции за зал. Зафиксируйте дату в июне-июле с предоплатой — это гарантирует нужный день без наценки.",
        "highlight": "Секрет: корпоратив в ноябре или январе стоит дешевле декабрьского, а атмосфера не хуже. Бронирование: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать зимний корпоратив",
      "href": "/korporativ"
    }
  },
  {
    "slug": "arenda-zala-korporativ-peterburg",
    "title": "Аренда зала для корпоратива в Петербурге: что нужно знать",
    "metaTitle": "Аренда зала для корпоратива в Петербурге — Паруса на крыше",
    "metaDescription": "Аренда банкетного зала для корпоратива в Санкт-Петербурге. «Паруса на крыше» — залы до 300 человек, без платы за аренду при заказе банкетного меню. Бронирование.",
    "keywords": "аренда зала корпоратив петербург, банкетный зал корпоратив спб, аренда зала мероприятие петербург",
    "date": "2026-06-11",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Аренда зала для корпоратива — не всегда то, что написано на сайте ресторана. Разбираем, как устроено ценообразование, что включено в стоимость и как не переплатить.",
    "sections": [
      {
        "heading": "Как работает «аренда зала» в ресторанах",
        "body": "В большинстве ресторанов Петербурга «аренда зала» — это не отдельная плата, а условие по минимальной сумме заказа. В «Парусах на крыше» зал предоставляется без дополнительной платы при заказе банкетного меню или à la carte на нужную сумму. Это значит: вы платите только за еду и напитки, аренда помещения включена. Такой подход прозрачный и честный.",
        "list": [
          "Аренда зала без дополнительной платы — при заказе банкетного меню",
          "Зал до 300 гостей с профессиональной сценой и оборудованием",
          "Банкетное меню от 2 500 ₽/чел. — минимальный заказ для зала",
          "Время аренды — до последнего гостя (уточняется при бронировании)"
        ]
      },
      {
        "heading": "Что включено в зал «Парусов»",
        "body": "В стандартную аренду зала входит: мебель (столы и стулья в нужной расстановке), профессиональное освещение, звуковое оборудование, экран или проектор (по запросу), гардероб. Декор зала — за дополнительную плату или со своим флористом. Персонал: официанты и барmen — в стоимости меню."
      },
      {
        "heading": "Как выбрать нужный зал",
        "body": "В «Парусах» несколько пространств. Для 20–50 гостей — выделенная зона в основном зале с панорамными окнами. Для 50–150 гостей — банкетный зал с отдельным входом. Для 150–300 гостей — полный банкетный зал с профессиональной сценой. Летом дополнительно — открытая терраса.",
        "highlight": "Для просмотра зала заранее: договоритесь о встрече с менеджером — вам покажут всё пространство и обсудят расстановку. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Обсудить аренду зала",
      "href": "/korporativ"
    }
  },
  {
    "slug": "svadba-vid-peterburg-rестораны",
    "title": "Свадьба с видом на Петербург: рестораны и идеи",
    "metaTitle": "Свадьба с видом на Петербург — рестораны 2026 | Паруса на крыше",
    "metaDescription": "Свадьба с видом на Санкт-Петербург — где провести? Лучшие рестораны с панорамой для свадебного банкета. «Паруса на крыше» — 6-й этаж, вид на центр.",
    "keywords": "свадьба вид петербург рестораны, свадьба панорама петербург, свадебный банкет вид петербург",
    "date": "2026-06-11",
    "category": "Свадьба",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Свадьба с видом на Петербург — мечта многих пар. Город с его архитектурой, куполами и набережными создаёт декорации, которые не купить ни за какие деньги. Вопрос только в том, из какого именно окна смотреть.",
    "sections": [
      {
        "heading": "Что значит «свадьба с видом на Петербург»",
        "body": "Видов на Петербург много — и они разные. Вид с набережной Невы: красиво, но нет высоты. Вид с крыши Исаакиевского собора: туристическая смотровая, не ресторан. Вид из отеля на верхнем этаже: зависит от отеля. Вид из «Парусов на крыше»: 6-й этаж Olympic Plaza, купола Казанского собора на уровне взгляда, 300° панорама центра — это один из лучших видов на Петербург, доступных в формате ресторана.",
        "list": [
          "Купола Казанского собора — на уровне взгляда из зала",
          "Крыши исторического центра — простираются до горизонта",
          "Нева — в дальней перспективе с террасы",
          "Вид меняется с временем суток — закат, вечер, ночь"
        ]
      },
      {
        "heading": "Свадебные фотографии с видом",
        "body": "Для свадебного фотографа «Паруса» — это место, где кадры получаются сами. Пара у панорамного окна с куполами на фоне. Первый танец с ночным Петербургом за стеклом. Групповое фото всех гостей с городом позади. Эти кадры — центральные в свадебном альбоме, они не требуют специального светового оборудования или ретуши."
      },
      {
        "heading": "Лучшее время суток для свадьбы с видом",
        "body": "Каждое время суток даёт свой вид. Дневная свадьба (14:00–18:00): дневное золото, чёткие силуэты зданий. Вечерняя свадьба с закатом (19:00–21:00): розово-оранжевое небо, самый красивый момент. Ночная свадьба (21:00+): огни города и иллюминация куполов. Летом все три сценария возможны: белые ночи продлевают световой день до полуночи.",
        "highlight": "Лучший момент для первого танца с видом: 20:30–21:00 летом (закатные лучи через панорамные окна) или 17:00–18:00 зимой (вечерние огни)."
      }
    ],
    "cta": {
      "text": "Обсудить свадьбу с видом на Петербург",
      "href": "/svadba"
    }
  },
  {
    "slug": "kak-organizovat-korporativ-restoran",
    "title": "Как организовать корпоратив в ресторане: советы и чек-лист",
    "metaTitle": "Как организовать корпоратив в ресторане — советы | Паруса на крыше",
    "metaDescription": "Пошаговое руководство по организации корпоратива в ресторане. Выбор места, меню, программа, бюджет. Советы от «Парусов на крыше» — 15 лет опыта мероприятий.",
    "keywords": "как организовать корпоратив ресторан советы, организация корпоратива ресторан петербург, корпоратив ресторан чек-лист",
    "date": "2026-06-12",
    "category": "Особые поводы",
    "readTime": 8,
    "image": "/photos/interior.webp",
    "lead": "Организация корпоратива в ресторане — задача, которую можно решить за 3 шага или завалить за 10. Делимся практическим опытом: что важно, что не важно, и что нужно уточнить у ресторана при первом звонке.",
    "sections": [
      {
        "heading": "Шаг 1: определите формат и бюджет",
        "body": "Первый вопрос — не «какой ресторан?», а «что это за мероприятие?». Это просто ужин командой или полноценный корпоратив с программой? Сколько человек? Какой бюджет на человека? В среднем по рынку: бюджет на корпоратив в хорошем ресторане Петербурга — 4 000–8 000 ₽/чел. включая еду, напитки и программу. В «Парусах на крыше» базовое банкетное меню — 2 500 ₽/чел., алкоголь — отдельно.",
        "list": [
          "Формат: ужин, банкет с программой или гибридный",
          "Количество гостей: от этого зависит размер зала",
          "Бюджет: 2 500–5 000 ₽/чел. — реалистичный диапазон",
          "Дата и время: дни недели vs. выходные, вечер vs. обед"
        ]
      },
      {
        "heading": "Шаг 2: выберите и забронируйте место",
        "body": "Критерии выбора ресторана для корпоратива: вместимость (нужный размер зала), возможности для программы (сцена, микрофон, экран), кухня (банкетное меню, которое нравится коллективу), атмосфера (место, которое создаёт нужный настрой). Не забудьте: бронируйте конкретную дату заранее и уточните условия по предоплате и отмене."
      },
      {
        "heading": "Шаг 3: согласуйте детали с менеджером",
        "body": "При первом звонке в ресторан уточните: расстановка столов под ваш формат, меню и варианты его персонализации, технические возможности (если нужна презентация или видео), включена ли аренда зала в стоимость меню, время, до которого работает ресторан для мероприятий. В «Парусах» на все эти вопросы можно ответить за один звонок: +7 (812) 991-10-90.",
        "highlight": "Чек-лист организатора: ✓ дата ✓ количество гостей ✓ формат (ужин/банкет) ✓ меню ✓ программа ✓ техника ✓ бюджет ✓ предоплата ✓ время работы."
      },
      {
        "heading": "Типичные ошибки при организации корпоратива",
        "body": "Ошибка 1: Бронировать слишком поздно (декабрьские даты заканчиваются в октябре). Ошибка 2: Не уточнять минимальный заказ для резервации зала. Ошибка 3: Не сообщать о технических потребностях (ноутбук, проектор, микрофон). Ошибка 4: Не предусматривать «запасной вариант» для открытых мероприятий. Подробнее о форматах корпоративов — в статье <a href=\"/blog/korporativ-na-kryshe-peterburg\" class=\"underline text-accent\">корпоратив на крыше в Петербурге</a>."
      }
    ],
    "cta": {
      "text": "Обсудить корпоратив с менеджером",
      "href": "/korporativ"
    }
  },
  {
    "slug": "romanticheskaya-progulka-peterburg",
    "title": "Романтическая прогулка по Петербургу: маршрут и ужин",
    "metaTitle": "Романтическая прогулка по Петербургу — маршрут и ужин | Паруса",
    "metaDescription": "Романтическая прогулка по Петербургу для пары. Лучшие маршруты и рестораны. «Паруса на крыше» — завершение вечера с видом на город. Бронирование.",
    "keywords": "романтическая прогулка петербург, прогулка для пары петербург, романтический вечер прогулка спб",
    "date": "2026-06-12",
    "category": "Романтика",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Романтическая прогулка по Петербургу — маршрут, который пишется сам: набережные, каналы, дворы-колодцы. Но хороший вечер заканчивается ужином — в правильном месте.",
    "sections": [
      {
        "heading": "Маршрут романтической прогулки по центру",
        "body": "Классический романтический маршрут: Невский проспект от площади Восстания → Казанский собор → Гостиный двор → набережная канала Грибоедова → Банковский мостик со львами → Спас на Крови → Михайловский сад → Русский музей. Итого: 3–4 км пешком, 1,5–2 часа в спокойном темпе. Заканчивайте ужином в «Парусах на крыше» (ул. Марата, 5) — от Русского музея 10 минут пешком.",
        "list": [
          "Невский → Казанский собор: 20 минут",
          "Канал Грибоедова → Банковский мостик: 15 минут",
          "Спас на Крови → Михайловский сад: 15 минут",
          "Ужин в «Парусах» с видом на Петербург: 2–2,5 часа"
        ]
      },
      {
        "heading": "Лучшее время для прогулки",
        "body": "Летом: прогулка в 18:00–20:00, ужин с закатом в 20:30–21:00 — идеальный тайминг. Осенью: прогулка до темноты, ужин в огнях вечернего города. Зимой: короткая прогулка (холодно!), но вид на заснеженный Петербург из окна «Парусов» компенсирует. Весной: первое тепло и прогулка вдоль каналов, потом ужин с видом на пробуждающийся город."
      },
      {
        "heading": "Ужин после прогулки: что заказать",
        "body": "После прогулки хочется чего-то тёплого и основательного. Хорошо работает: суп дня или горячая закуска, горячее блюдо (стейк или паста), десерт и горячий напиток. В «Парусах» это всё есть в авторском исполнении. Если шли долго — начните с хлеба и масла, которые приносят к столу сразу.",
        "highlight": "Лайфхак: бронируйте стол заранее на 20:30 и приходите к этому времени прямо с прогулки. Вид на закат над Петербургом будет в самом разгаре."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после прогулки",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "gde-vstretit-belye-nochi-vdvoem-peterburg",
    "title": "Где встретить белые ночи вдвоём в Петербурге",
    "metaTitle": "Где встретить белые ночи вдвоём в Петербурге — Паруса на крыше",
    "metaDescription": "Как встретить белые ночи в Петербурге с любимым человеком? «Паруса на крыше» — ужин с видом на ночной город, живая музыка, открытая терраса. Бронирование.",
    "keywords": "белые ночи вдвоём петербург, встретить белые ночи пара петербург, белые ночи романтика спб",
    "date": "2026-06-12",
    "category": "Романтика",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Белые ночи в Петербурге — явление, которое нужно пережить хотя бы раз. Особенно вдвоём: когда в полночь небо остаётся светлым, а Петербург не спит.",
    "sections": [
      {
        "heading": "Почему белые ночи — лучшее время для пары",
        "body": "Белые ночи (конец мая — середина июля) создают в Петербурге уникальную атмосферу: светлые ночи, ощущение нескончаемого вечера, город не засыпает. Для пары это означает: ужин в 22:00 под светлым небом, прогулка по набережной в полночь, рассвет (который на самом деле не кончался). В «Парусах на крыше» белые ночи видны с 6-го этажа Olympic Plaza — светлое небо над куполами и крышами в 23:00.",
        "list": [
          "Светлое небо в 23:00–01:00 — видно с террасы",
          "Открытая терраса в белые ночи — ужин под открытым небом",
          "Живая музыка вечером — атмосфера белой ночи",
          "Разводка мостов рядом: Благовещенский мост — 15 минут пешком"
        ]
      },
      {
        "heading": "Программа вечера белых ночей для пары",
        "body": "Рекомендуемый сценарий: ужин в «Парусах» в 20:00–22:00 (закат и начало белой ночи), прогулка по набережной Невы (22:00–01:00), наблюдение за разводкой мостов (Благовещенский и Дворцовый — с 01:30). Итого — незабываемый вечер длиной в ночь."
      },
      {
        "heading": "Что особенного в белых ночах для ресторана",
        "body": "В белые ночи «Паруса» работают дольше. Терраса открыта до поздна. Атмосфера в зале другая: светлое небо за окном в час ночи — это петербургское чудо, которое гости не ожидают и которое запоминается навсегда.",
        "highlight": "21–24 июня — пик белых ночей. Бронируйте стол на открытой террасе за 2–3 недели: это самые востребованные вечера года. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать вечер белых ночей",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "gde-vstretit-zakat-peterburg-restoran",
    "title": "Где встретить закат в Петербурге: рестораны и смотровые точки",
    "metaTitle": "Где встретить закат в Петербурге — рестораны с видом | Паруса на крыше",
    "metaDescription": "Лучшие места для встречи заката в Санкт-Петербурге. Рестораны с видом на закат. «Паруса на крыше» — ужин с видом на закатное небо над куполами.",
    "keywords": "встретить закат петербург ресторан, закат петербург где смотреть, закат над петербургом вид ресторан",
    "date": "2026-06-12",
    "category": "Романтика",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Закат в Петербурге — один из самых красивых видов в мире. Розово-оранжевое небо над куполами, отражения в Неве, тени на крышах центра. Вопрос только: откуда смотреть.",
    "sections": [
      {
        "heading": "Лучшие точки для заката в Петербурге",
        "body": "Есть несколько категорий мест. Набережные Невы: уровень земли, красиво, но нет высоты. Смотровые площадки (Исаакиевский собор, Петропавловка): высокие, но нет комфорта. Рестораны на верхних этажах: высота + комфорт + кухня. «Паруса на крыше» — лучшая комбинация всех трёх: 6-й этаж с видом на запад, закат приходит прямо в окна панорамного зала.",
        "list": [
          "6-й этаж — одна из лучших высотных точек в этой части центра",
          "Западная экспозиция зала — закат прямо в окна",
          "Комфорт ресторана + авторская кухня + вино",
          "Летом закат в 21:00–22:30 — дольший «золотой час»"
        ]
      },
      {
        "heading": "Лучшее время для заката в «Парусах»",
        "body": "Время заката в Петербурге: июнь — около 22:30–23:00, август — около 20:30–21:00, сентябрь — около 18:30–19:30, октябрь — около 17:00–18:00. Бронируйте стол за 30–45 минут до захода солнца: нужно успеть заказать аперитив и насладиться переходом от золотого часа к сумеркам. Попросите столик у западного окна."
      },
      {
        "heading": "Закат как повод для особого вечера",
        "body": "Встреча заката в ресторане — готовый сценарий для свидания без лишних слов. Пара садится, заказывает бокал вина, смотрит, как небо над Казанским собором меняет цвет. Разговор возникает сам. В «Парусах» этот момент работает вне зависимости от повода — первое свидание, годовщина или просто пятница после работы.",
        "highlight": "Закатный столик у западного окна — запрашивайте при бронировании. В июне-июле это самый популярный запрос: бронируйте за 5–7 дней."
      }
    ],
    "cta": {
      "text": "Забронировать стол на закат",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "godovshchina-svadby-spb-restoran",
    "title": "Годовщина свадьбы: где отметить в ресторане СПб",
    "metaTitle": "Годовщина свадьбы в ресторане СПб — Паруса на крыше | Романтика",
    "metaDescription": "Где отметить годовщину свадьбы в Петербурге? «Паруса на крыше» — романтический ужин с видом на город, живая музыка, авторская кухня. Специальные условия для пар.",
    "keywords": "годовщина свадьбы ресторан спб, отметить годовщину свадьбы петербург, ресторан годовщина пара петербург",
    "date": "2026-06-13",
    "category": "Свадьба",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "Годовщина свадьбы — один из тех поводов, который легко забыть в повседневном ритме и который потом хочется вернуть. Правильное место напоминает о том, зачем всё это.",
    "sections": [
      {
        "heading": "Годовщина свадьбы в «Парусах»: что особенного",
        "body": "«Паруса на крыше» — ресторан, куда многие пары возвращаются год за годом. Для годовщины свадьбы здесь можно забронировать тот же столик, что занимали в прошлый раз (или на свадьбе, если она проходила здесь). Персонал помнит постоянных гостей. Шеф-повар может подготовить специальный десерт с датой и именами. Это называется «restaurant that knows you» — и работает лучше любого пафоса.",
        "list": [
          "Тот же столик год за годом — создаёт традицию",
          "Специальный десерт с датой — по запросу",
          "Живые цветы на столе — по запросу при бронировании",
          "Шампанское от ресторана — для особого повода"
        ]
      },
      {
        "heading": "Идеи для годовщины в ресторане",
        "body": "Первая годовщина (бумажная): ужин с распечатанными любимыми фото этого года. Пятая (деревянная): закажите деревянную подставку для меню с вашими именами — необычный сувенир. Десятая (оловянная): пригласите тех гостей свадьбы, кто был особенно важен. Двадцать пятая (серебряная): торжественный ужин с теми же блюдами, что были на свадьбе."
      },
      {
        "heading": "Практические детали",
        "body": "Для годовщины бронируйте за 5–7 дней. При бронировании обязательно укажите «годовщина свадьбы» — это активирует особое внимание от персонала. Если хотите специальный десерт — сообщите за 2–3 дня, шеф-повар успеет подготовить.",
        "highlight": "Скидка 20% на счёт именинника действует и для годовщины, если один из партнёров — именинник в это время. Уточните условия при бронировании."
      }
    ],
    "cta": {
      "text": "Забронировать ужин на годовщину",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "svadba-50-chelovek-restoran-peterburg",
    "title": "Свадьба на 50 человек в ресторане Петербурга: организация",
    "metaTitle": "Свадьба на 50 человек в ресторане Петербурга — Паруса на крыше",
    "metaDescription": "Свадьба на 50 человек в ресторане Санкт-Петербурга. «Паруса на крыше» — банкетный зал с видом, свадебное меню, живая музыка. Цены и организация.",
    "keywords": "свадьба 50 человек ресторан петербург, свадебный банкет 50 человек спб, свадьба пятьдесят гостей петербург",
    "date": "2026-06-13",
    "category": "Свадьба",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Свадьба на 50 человек — это баланс: достаточно гостей для настоящего праздника и достаточно мало, чтобы пара могла уделить внимание каждому. Идеальный размер для петербургского ресторанного торжества.",
    "sections": [
      {
        "heading": "50 гостей: что это значит логистически",
        "body": "Пятьдесят человек требуют: выделенного пространства (минимум 75–100 кв.м), синхронной подачи блюд (все едят одновременно), профессионального сервиса (минимум 3–4 официанта на зал), и микрофона для тостов. В «Парусах на крыше» банкетный зал на 50–100 гостей оснащён всем необходимым: сцена, звук, свет, и панорамный вид на Петербург как главная декорация.",
        "list": [
          "Банкетный зал 50–100 гостей с профессиональной сценой",
          "4–5 официантов для вашей группы",
          "Синхронная подача трёх перемен блюд",
          "Банкетное свадебное меню от 2 500 ₽/чел."
        ]
      },
      {
        "heading": "Планирование свадьбы на 50: временной план",
        "body": "6–8 месяцев до: выбор даты и ресторана, первая встреча с менеджером. 4–5 месяцев: согласование меню и программы, выбор ведущего. 2–3 месяца: финализация деталей оформления, дегустация меню. 2 недели: последние уточнения по численности, тайминг программы. 1 день до: репетиция у менеджера, расстановка рассадки."
      },
      {
        "heading": "Бюджет свадьбы на 50 человек",
        "body": "Банкетное меню 2 500 ₽ × 50 = 125 000 ₽. Алкоголь: 1 000 ₽ × 50 = 50 000 ₽. Ведущий: 30 000–60 000 ₽. Живая музыка: 30 000–50 000 ₽. Оформление зала: 20 000–50 000 ₽. Торт: 15 000–30 000 ₽. Итого: 270 000–365 000 ₽. Для свадьбы в центре Петербурга с панорамным видом — конкурентный бюджет.",
        "highlight": "Дегустация свадебного меню: большинство ресторанов предлагают её бесплатно при бронировании. Попросите у менеджера «Парусов» организовать дегустацию заранее."
      }
    ],
    "cta": {
      "text": "Обсудить свадьбу на 50 человек",
      "href": "/svadba"
    }
  },
  {
    "slug": "romanticheskiy-uzhin-s-vidom-spb",
    "title": "Романтический ужин с видом в Петербурге: топ мест",
    "metaTitle": "Романтический ужин с видом в Петербурге — топ мест | Паруса на крыше",
    "metaDescription": "Романтический ужин с видом на Петербург. «Паруса на крыше» — панорама 300°, авторская кухня, живая музыка. Лучшие рестораны с видом для романтического вечера.",
    "keywords": "романтический ужин вид петербург, ресторан вид романтика спб, романтический вечер ресторан вид петербург",
    "date": "2026-06-13",
    "category": "Романтика",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Романтический ужин с видом на Петербург — формат, который попадает в самую точку. Красивое место снимает необходимость придумывать «программу» — Петербург за окном уже является программой.",
    "sections": [
      {
        "heading": "Что значит «с видом» для романтического ужина",
        "body": "«Вид» для романтического ужина — это не фотообои с Эйфелевой башней на стене и не открытка с Невой на меню. Это живой, настоящий вид, который меняется в течение вечера. В «Парусах на крыше» этот вид — реальность: на 6-м этаже Olympic Plaza панорамные окна открывают 300° обзора исторического центра. Казанский собор справа, крыши уходят к горизонту, Нева блестит вдали. Этот вид не нужно описывать — он работает сам.",
        "list": [
          "300° панорама — не одна точка, а живой вид в нескольких направлениях",
          "Закат приходит прямо в окна — летом около 21:00–22:00",
          "Ночные огни города сменяют закат — ужин в двух «декорациях»",
          "Каждый сезон — свой вид: золото осени, снег зимой, цветение весной"
        ]
      },
      {
        "heading": "Сравнение романтических вариантов в Петербурге",
        "body": "Ужин на теплоходе: красивый маршрут, но кухня ограниченная и шумно. Ресторан на Рубинштейна: отличная кухня, но без вида и тесновато. Загородный ресторан: романтичная обстановка, но дорогая поездка. Летняя терраса у Невы: красиво, но сезонно и зависит от погоды. «Паруса на крыше»: вид + кухня + музыка + приватность + всесезонность в одном месте."
      },
      {
        "heading": "Как забронировать романтический столик с видом",
        "body": "Позвоните или оставьте заявку онлайн: +7 (812) 991-10-90. При бронировании укажите: «романтический ужин», пожелание по столику (у окна), желаемое время. Если планируете особый вечер (годовщина, предложение) — скажите об этом, персонал подготовится. Бронировать лучше за 3–5 дней, в выходные — за 7–10 дней.",
        "highlight": "Лучший столик для романтики: угловой у западного окна на закат. Бронируйте с пометкой «столик у окна» — ресторан учтёт это."
      }
    ],
    "cta": {
      "text": "Забронировать романтический ужин с видом",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "peterburg-dlya-dvoyh-kuda-pojti",
    "title": "Петербург для двоих: куда пойти и что сделать",
    "metaTitle": "Петербург для двоих — куда пойти и что сделать | Паруса на крыше",
    "metaDescription": "Петербург для двоих: лучшие идеи для пары. Прогулки, рестораны, романтические места. «Паруса на крыше» — ужин с видом на город для завершения идеального дня.",
    "keywords": "петербург двоих куда пойти что сделать, пара петербург идеи, романтика пара петербург",
    "date": "2026-06-13",
    "category": "Романтика",
    "readTime": 7,
    "image": "/photos/view_summer.webp",
    "lead": "Петербург для двоих — это целый жанр. Город создан для влюблённых: каналы, дворы-колодцы, кованые мосты, купола, видимые с любого угла. Вопрос только в том, как выстроить день, чтобы запомниться.",
    "sections": [
      {
        "heading": "Утро: как начать день в Петербурге",
        "body": "Идеальное утро для пары в Петербурге: завтрак в ресторане с видом (в «Парусах» завтраки в выходные) → прогулка по утреннему Невскому, который ещё не заполнился туристами → кофе во дворе-колодце в Коломне → Эрмитаж или Русский музей по желанию. Утренний Петербург совсем другой: тихий, золотой, настоящий."
      },
      {
        "heading": "День: что посмотреть вместе",
        "body": "Лучший пешеходный маршрут для пары: Казанский собор (если не были — стоит зайти) → Греческий мостик → Михайловский замок → Летний сад (если открыт) → набережная Фонтанки → ул. Рубинштейна с её ресторанами и кофейнями. Итого 5–6 км, 2–3 часа в прогулочном темпе.",
        "list": [
          "Казанский собор: 20 минут на осмотр",
          "Михайловский замок: 45 минут внутри или просто снаружи",
          "Летний сад: 30 минут среди скульптур",
          "Набережная Фонтанки: просто идти и смотреть"
        ]
      },
      {
        "heading": "Вечер: романтический ужин с видом",
        "body": "Завершение дня в «Парусах на крыше»: ужин в 19:30–20:00, закат над Петербургом в окне, живая музыка, авторская кухня, бокал вина. Этот финал превращает даже обычный день в запоминающийся. От ул. Рубинштейна до «Парусов» — 5 минут пешком.",
        "highlight": "Маршрут дня для пары: утро → прогулка по центру → Паруса на ужин. Бронируйте ужин заранее, чтобы гарантировать столик у окна: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать романтический ужин",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "banketnyy-zal-svadba-peterburg",
    "title": "Банкетный зал для свадьбы в центре Петербурга: как выбрать",
    "metaTitle": "Банкетный зал для свадьбы в центре Петербурга — Паруса на крыше",
    "metaDescription": "Как выбрать банкетный зал для свадьбы в центре Петербурга? «Паруса на крыше» — залы до 300 человек с видом на город, профессиональная сцена, свадебное меню.",
    "keywords": "банкетный зал свадьба петербург центр, зал для свадьбы петербург, свадебный зал центр спб",
    "date": "2026-06-14",
    "category": "Свадьба",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Выбор банкетного зала для свадьбы — решение, от которого зависит всё остальное: меню, программа, оформление. Разбираем, на что смотреть и что спрашивать у менеджера при первом визите.",
    "sections": [
      {
        "heading": "На что смотреть при выборе зала",
        "body": "Пять ключевых критериев: 1. Площадь и вместимость — минимум 1,5 кв.м/гость для комфортного сидячего формата. 2. Технические возможности — сцена, звук, свет, микрофон. 3. Вид и атмосфера — место должно нравиться сразу, без «нужно привыкнуть». 4. Кухня — дегустируйте меню до финального решения. 5. Сервис — как с вами говорят менеджеры до подписания договора, так и будут вести на свадьбе.",
        "list": [
          "Вместимость: до 300 гостей в «Парусах»",
          "Техника: профессиональная сцена, звук, свет — в комплекте",
          "Атмосфера: вид на Петербург — лучший аргумент",
          "Кухня: дегустация меню до подписания договора"
        ]
      },
      {
        "heading": "Вопросы для менеджера зала",
        "body": "При первом визите обязательно спросите: какой минимальный заказ для брони зала? что включено в аренду (стулья, скатерти, посуда)? можно ли приходить своим декоратором? до которого часа работает зал? есть ли зона для фотосессии? можно ли пробовать меню заранее? Ответы на эти вопросы определят, подходит ли зал вашей свадьбе."
      },
      {
        "heading": "Центр Петербурга vs. периферия",
        "body": "Многие пары выбирают загородные усадьбы ради природы и «неожиданных» фотографий. Но для гостей, которые приезжают из других городов и стран, центр Петербурга — это сам по себе декорация. Банкетный зал «Парусов на крыше» с видом на исторический центр создаёт «петербургскую свадьбу» — событие, которое невозможно повторить в другом городе.",
        "highlight": "Посетите зал лично до бронирования — в «Парусах» можно договориться об экскурсии по помещению. Звоните: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Посмотреть банкетный зал для свадьбы",
      "href": "/svadba"
    }
  },
  {
    "slug": "vyezdnaya-registratsiya-banket-spb",
    "title": "Выездная регистрация с банкетом в ресторане СПб",
    "metaTitle": "Выездная регистрация с банкетом в ресторане СПб — Паруса на крыше",
    "metaDescription": "Выездная регистрация брака с банкетом в ресторане Санкт-Петербурга. «Паруса на крыше» — зал с видом на город, возможность выездной регистрации и банкета в одном месте.",
    "keywords": "выездная регистрация банкет спб, регистрация брака ресторан петербург, выездная регистрация ресторан спб",
    "date": "2026-06-14",
    "category": "Свадьба",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Выездная регистрация с последующим банкетом в одном месте — удобнейший формат для пары, которая хочет красивой церемонии без суеты переезда. Петербург даёт для этого идеальный фон.",
    "sections": [
      {
        "heading": "Как работает выездная регистрация в «Парусах»",
        "body": "Выездная регистрация — это когда официальный регистратор (или организованный через ЗАГС выездной специалист) проводит церемонию бракосочетания непосредственно в ресторане. После церемонии гости остаются на том же месте — переходят к банкетным столам. Никакого переезда, никакой потери атмосферы. В «Парусах на крыше» для этого есть пространство с видом на Петербург — церемония на фоне купола Казанского собора, затем банкет в том же зале.",
        "list": [
          "Церемония в зале ресторана — с видом на Петербург",
          "Официальный регистратор приезжает в ресторан",
          "Банкет сразу после церемонии — без переезда",
          "Один адрес для всех гостей: ул. Марата 5, Olympic Plaza"
        ]
      },
      {
        "heading": "Организация выездной регистрации",
        "body": "Для выездной регистрации в России нужно подать заявление в ЗАГС и указать желаемое место. Некоторые ЗАГСы Петербурга предоставляют выездную услугу. Альтернатива — символическая церемония (не имеющая юридической силы, но красивая как ритуал) с последующей официальной регистрацией в ЗАГСе. Ресторан помогает скоординировать пространство под любой формат."
      },
      {
        "heading": "Практические вопросы",
        "body": "Место для церемонии: нужна площадь для арки или «алтаря», стулья для гостей, свободный проход. В «Парусах» это организовывается в банкетном пространстве — уточните при бронировании. Музыка для церемонии: живой квартет или скрипка — по запросу. Фотограф: ресторан может порекомендовать проверенных свадебных фотографов, которые знают пространство.",
        "highlight": "Выездная регистрация + банкет в одном месте экономит 2–3 часа и убирает стресс переезда. Обсудите этот формат с менеджером: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Обсудить выездную регистрацию",
      "href": "/svadba"
    }
  }
];
